import useEffectWithCtx from 'src/hooks/useEffectUtils/useEffectWithCtx';
export default function useMarkQuestionReadOnDwell(questionID, state, actions) {
    useEffectWithCtx(ctx => {
        const details = ctx.state.questionDetailsQuery.data?.ep_questionDetails;
        if (details?.answer?.id && !details.userData?.read) {
            const timer = setTimeout(() => ctx.actions.updateReadMutation.update({
                variables: { questionID, read: true },
            }), __DEV__ ? 3_000 : 10_000);
            return () => clearTimeout(timer);
        }
    }, { state, actions }, [state.questionDetailsQuery.data?.ep_questionDetails?.answer?.id, questionID]);
}
